import React, { useEffect, useState } from 'react'
import { constraintsApi } from '../lib/api.js'

const PRESETS = [
  { id: 'vege', label: '🌱 Végé' },
  { id: 'pesce', label: '🐟 Pescé' },
  { id: 'quick', label: '⚡ < 30 min' },
  { id: 'kids', label: '👶 Kids-friendly' },
  { id: 'no-pork', label: '🚫 Sans porc' },
  { id: 'budget', label: '💰 Budget' },
  { id: 'leftovers', label: '🍱 Restes OK' },
]

const STORAGE_KEY = 'betina_planner_constraints'

export function ConstraintsChips({ onChange }) {
  const [active, setActive] = useState(() => {
    try {
      return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]'))
    } catch {
      return new Set()
    }
  })
  const [synced, setSynced] = useState(false)

  // Hydrate from server once on mount, then keep client + server in sync.
  useEffect(() => {
    let cancelled = false
    constraintsApi
      .get()
      .then((server) => {
        if (cancelled) return
        const serverSet = new Set(Array.isArray(server) ? server : [])
        // Server wins if non-empty; otherwise keep local.
        if (serverSet.size) {
          setActive(serverSet)
          localStorage.setItem(STORAGE_KEY, JSON.stringify([...serverSet]))
        }
        setSynced(true)
      })
      .catch(() => setSynced(true))
    return () => {
      cancelled = true
    }
  }, [])

  // Push changes upstream (debounced via mount-effect dependency).
  useEffect(() => {
    if (!synced) return
    const arr = [...active]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr))
    onChange?.(arr)
    constraintsApi.set(arr).catch(() => {})
  }, [active, synced])

  function toggle(id) {
    setActive((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }

  return (
    <div className="-mx-4 px-4 overflow-x-auto scrollbar-hide">
      <div className="flex gap-2 py-1 w-max">
        {PRESETS.map((p) => {
          const on = active.has(p.id)
          return (
            <button
              key={p.id}
              onClick={() => toggle(p.id)}
              className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${
                on
                  ? 'bg-emerald-600 border-emerald-600 text-white'
                  : 'bg-white border-gray-200 text-gray-600 hover:border-emerald-300'
              }`}
              aria-pressed={on}
            >
              {p.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
